import React from "react";
import {useTranslation} from "react-i18next";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import Icon from "@mui/material/Icon";
import MDButton from "materialDashboard/components/MDButton";
import MDTypography from "materialDashboard/components/MDTypography";
import IconButton from "@mui/material/IconButton";
import WithInfoTooltip from "./WithInfoTooltip";


const handleAddMeasure = (measurements, createEmptyMeasure, index) => {

    if (index === undefined || index === null) {
        const lastMeasure = measurements?.length > 0 ? measurements[measurements.length - 1] : null;
        return [...measurements, createEmptyMeasure(lastMeasure)]
    } else {
        const newMeasure = createEmptyMeasure(measurements?.[index - 1], measurements?.[index]);
        return [...measurements.slice(0, index), newMeasure, ...measurements.slice(index)]
    }
}

const handleDeleteMeasure = (measurements, index) => {
    return [...measurements.slice(0, index), ...measurements.slice(index + 1)]
}


export const renderHeader = (name, info) => {
    return <WithInfoTooltip message={info}>
        <MDTypography key={name} variant="caption"
                      sx={{fontWeight: "500", minWidth: "5rem"}}>{name}</MDTypography>
    </WithInfoTooltip>
}

const MeasurementsList = ({
                              headers,
                              measurements,
                              createEmptyMeasure,
                              onMeasurementsUpdate,
                              renderMeasure = f => f,
                              renderEmptyButton = f => f,
                              inputDisabled
                          }) => {
    const {t} = useTranslation(['models23']);
    const col = headers.length + 1; // +1 for the action column

    return <Stack spacing={2}>
        <Stack spacing={2} sx={{overflowX: "auto"}}>
            <Box display="grid"
                 gridTemplateColumns={`repeat(${col}, 1fr)`}
                 gap={2}
                 sx={{pb: 1, borderBottom: 1, borderColor: "divider"}}>

                {
                    headers.map((header) => {
                        // if header is a string use MdTypography to display it, otherwise render it as a component
                        if (typeof header === "string") {
                            return <MDTypography key={header} variant="caption"
                                                 sx={{fontWeight: "500", minWidth: "5rem"}}>{header}</MDTypography>
                        } else {
                            return header;
                        }
                    })
                }

                <MDTypography variant="caption" sx={{fontWeight: "500"}}>{t('model23Form.actions')}</MDTypography>

                {
                    measurements.map((row, index) => <React.Fragment key={row._key}>
                        {renderMeasure(row, index)}
                        {
                            !inputDisabled && <Box sx={{display: "flex", gap: 1, justifyContent: "center", alignItems: "center", flexWrap: "noWrap"}}>
                                <IconButton
                                    onClick={() => onMeasurementsUpdate(handleAddMeasure(measurements, createEmptyMeasure, index + 1))}>
                                    <Icon fontSize="small" color="success">add</Icon>
                                </IconButton>
                                <IconButton onClick={() => onMeasurementsUpdate(handleDeleteMeasure(measurements, index))}>
                                    <Icon fontSize="small" color="error">delete</Icon>
                                </IconButton>
                            </Box>
                        }
                        </React.Fragment>
                    )
                }
            </Box>
        </Stack>

        {
            measurements.length === 0 && <Stack sx={{jusitfyContent: "center", alignItems: "center"}}>
                <MDTypography variant="body2" color="secondary" align="center">
                    <Icon fontSize="large">inbox</Icon><br/>
                    {t('model23Form.noMeasure')}
                </MDTypography>
                {!inputDisabled && renderEmptyButton()}
            </Stack>
        }

        {
            !inputDisabled && <MDButton variant="text" color="info"
                                        sx={{alignSelf: "end"}}
                                        onClick={() => onMeasurementsUpdate(handleAddMeasure(measurements, createEmptyMeasure))}>
                {t('model23Form.addLayer')}
            </MDButton>
        }
    </Stack>
}

export default MeasurementsList;